import { Model, ModelAttributes, model, modelConfig } from "@mixitone/oom";
import { setAccountId } from "./concerns/SetAccountId";

const config = modelConfig(
  {
    account_id: {
      type: "string",
    },
    club_id: {
      type: "string",
    },
    club_player_id: {
      type: "string",
    },
    created_at: {
      type: "datetime",
    },
    ended_at: {
      type: "datetime",
    },
    ended_reason: {
      type: "string",
    },
    is_deleted: {
      type: "boolean",
    },
    started_at: {
      type: "datetime",
    },
    updated_at: {
      type: "datetime",
    },
  },
  {
    // Add collections here if needed
  },
  {
    // Add references here if needed
  },
);

interface ClubPlayerMembership extends ModelAttributes<typeof config> {}

@setAccountId
@model("club_player_memberships", config)
class ClubPlayerMembership extends Model<typeof config> {}

export default ClubPlayerMembership;
